import { render, staticRenderFns } from "./devices.vue?vue&type=template&id=78588ffb&scoped=true"
import script from "./devices.vue?vue&type=script&lang=js"
export * from "./devices.vue?vue&type=script&lang=js"
import style0 from "./devices.vue?vue&type=style&index=0&id=78588ffb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78588ffb",
  null
  
)

export default component.exports